module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('c-settings'), _vm._v(" "), _c('div', {
    staticClass: "page-wrapper",
    staticStyle: {
      "background": "#ffffff"
    },
    attrs: {
      "id": "topwrap"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.header_data
    }
  }), _vm._v(" "), (_vm.$route.query.upgrade) ? _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [(_vm.set_upgrade_plans) ? _c('section', {
    staticClass: "pricing-style-one",
    staticStyle: {
      "background": "#f0eeef",
      "margin-top": "5em"
    },
    attrs: {
      "id": "pricing"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-5em"
    }
  }, [(!_vm.set_upgrade_plan_process) ? _c('div', {
    staticClass: "container"
  }, [(_vm.upgradable_plans.length == 0) ? _c('div', {
    staticClass: "block-title text-center"
  }, [_c('h2', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("Sorry, no plans to upgrade to.")])]) : _c('div', {
    staticClass: "block-title text-center"
  }, [_c('h2', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("Select a plan to upgrade")])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane show active  animated fadeInUp",
    attrs: {
      "role": "tabpanel"
    }
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.upgradable_plans), function(plan) {
    return _c('div', {
      staticClass: "col-lg-4 col-md-6 col-sm-12"
    }, [_c('div', {
      staticClass: "card-purchase basic-pack"
    }, [_c('div', {
      staticClass: "top-block"
    }, [((plan.product_items && plan.product_items.length > 0)) ? _c('span', {
      staticClass: "price"
    }, [_vm._v("₦" + _vm._s(plan.featured_plan.product_item_price))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "pack-name"
    }, [_vm._v(_vm._s(plan.product_name))]), _vm._v(" "), _c('div', {
      staticClass: "line"
    })]), _vm._v(" "), (plan.product_items.length > 0) ? _c('div', _vm._l((plan.product_items), function(item) {
      return _c('li', {
        staticStyle: {
          "list-style": "none"
        }
      }, [_vm._v("\r\n                                                        _ "), _c('b', [_vm._v(_vm._s(item.product_item_service_tag))]), _vm._v(" - "), _c('span', [_vm._v("₦" + _vm._s(_vm.setCurrency(item.product_item_price)))])])
    })) : _vm._e(), _vm._v(" "), (plan.product_url_name == 'plan1') ? _c('ul', {
      staticClass: "feature-lists"
    }, [_c('li', [_vm._v("Extra features")]), _vm._v(" "), _c('li', [_vm._v("Lifetime free support")]), _vm._v(" "), _c('li', [_vm._v("Upgrate options")]), _vm._v(" "), _c('li', [_vm._v("Full access")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "bottom-block"
    }, [_c('p', {
      staticClass: "sp-form-descr"
    }, [_vm._v("Your Upgrade details would be calculated appropriately when you choose plan")]), _vm._v(" "), _c('a', {
      staticClass: "price-btn",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.upgrade_plan(plan)
        }
      }
    }, [_vm._v("Purchase")])])])])
  }))])])]) : _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "10em"
    }
  }, [_vm._m(1), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(2)]) : _c('div', {
    staticClass: "row"
  }, [(_vm.setup_error_message != '') ? _c('div', {
    staticClass: "row onboarding-head"
  }, [_c('div', {
    staticClass: "col",
    staticStyle: {
      "margin": "5em",
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#000000",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.setup_error_message) + ".")])])]) : _c('div', [_c('div', {
    staticClass: "row onboarding-body"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-xs-12 col-md-6 offset-md-4 onboarding-center"
  }, [_c('div', [_c('h6', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Upgrade Plans")]), _vm._v(" "), (_vm.selected_plan && _vm.selected_plan.product_items) ? _c('h4', [_c('b', [_vm._v(_vm._s(_vm.selected_plan.product_name) + "(₦" + _vm._s(_vm.setCurrency(_vm.selected_plan_product_service_item.product_item_price)) + ")")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {}, [_c('div', [_vm._l((_vm.selected_plan.product_items_upgrade_details), function(details) {
    return _c('div', {}, [(_vm.selected_plan_product_service_item.product_item_id == details.subscription_new_product_item_id) ? _c('div', [(details.subscription_is_unlimited == 0) ? _c('div', [_c('p', [_vm._v("Your last Subscription was on:"), _c('b', [_vm._v(_vm._s(details.subscription_subscribed_product_start_date))]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("You have "), _c('b', [_vm._v(_vm._s(details.subscription_subscribed_product_days_left))]), _vm._v(" days before your subscription expires.")])]) : _vm._e(), _vm._v(" "), ((details.subscription_new_product_total_amount_to_pay > 0)) ? _c('p', [_vm._v("To upgrade to this plan, the total sum to pay is "), _c('b', [_vm._v("₦" + _vm._s(_vm.setCurrency(details.subscription_new_product_total_amount_to_pay)))])]) : _c('p', [_vm._v("Sorry, you can not purchase this plan yet.")])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {}, [_c('form', {
    staticClass: "gw-form"
  }, [(_vm.selected_plan.product_items_upgrade_details.subscription_new_product_total_amount_to_pay > 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Subscription Duration: "), _c('b', [_vm._v(_vm._s(_vm.selected_plan_product_service_item.product_item_service_tag))])]), _c('br'), _vm._v(" "), _c('label', [_c('p', {
    staticClass: "sp-form-descr"
  }, [_c('b', [_vm._v("Total to pay: ₦" + _vm._s(_vm.setCurrency(_vm.selected_plan_product_service_item.product_item_price)))])])])]) : _vm._e(), _vm._v(" "), (_vm.selected_plan.product_items && (_vm.selected_plan.product_items.length > 1)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "gw-btn-cta-light",
    staticStyle: {
      "color": "#000000"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('display-product_service_items', '')
      }
    }
  }, [_vm._v("\r\n                                                                    Change Subscription Duration\r\n                                                                ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "border": "#aa076b dashed",
      "margin-top": "6px",
      "padding": "5px"
    },
    attrs: {
      "id": "productServiceItems"
    }
  }, _vm._l((_vm.selected_plan.product_items), function(pt) {
    return _c('div', {
      staticClass: "radio-items"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_service_items_select),
        expression: "product_service_items_select"
      }],
      attrs: {
        "type": "radio",
        "id": pt.product_item_id
      },
      domProps: {
        "value": pt.product_item_id,
        "checked": _vm._q(_vm.product_service_items_select, pt.product_item_id)
      },
      on: {
        "click": function($event) {
          _vm.selectProductServiceItem(pt)
        },
        "__c": function($event) {
          _vm.product_service_items_select = pt.product_item_id
        }
      }
    }), _vm._v(_vm._s(pt.product_item_service_tag) + "\r\n                                                                    ")])
  }))]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.payment_successful) ? _c('div', {}, [_c('h3', {
    staticStyle: {
      "color": "#7c0b0b",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.payment_successful_message))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), (_vm.selected_plan.product_items_upgrade_details.subscription_new_product_total_amount_to_pay > 0) ? _c('button', {
    staticClass: "btn pull-left gw-btn-cta-light",
    staticStyle: {
      "cursor": "pointer",
      "color": "#000000"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.proceedUpgradePlan()
      }
    }
  }, [_vm._v(" Proceed")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    staticStyle: {
      "background": "#f0de3d",
      "cursor": "pointer",
      "color": "#000000"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(" Cancel")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2)])])])])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "5em"
    }
  }, [(_vm.set_purchase_process) ? _c('section', {
    staticClass: "home-page-two gw-banner-plain",
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('button', {
    staticClass: "btn pull-right",
    staticStyle: {
      "margin-top": "1em",
      "background": "#f0de3d",
      "cursor": "pointer",
      "color": "#000000"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(" Cancel")]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(4)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row onboarding-head",
    staticStyle: {
      "background": "#000000",
      "color": "#ffffff",
      "padding": "5em",
      "margin-bottom": "1em"
    }
  }, [(_vm.setup_error_message != '') ? _c('div', {
    staticClass: "col",
    staticStyle: {
      "margin": "5em",
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#ffffff",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.setup_error_message) + ".")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('h6', {
    staticClass: "gw-mobile",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Purchase Plans")]), _vm._v(" "), (_vm.selected_plan && _vm.selected_plan.product_items) ? _c('h4', [_c('b', [_vm._v(_vm._s(_vm.selected_plan.product_name) + "(₦" + _vm._s(_vm.setCurrency(_vm.selected_plan_product_service_item.product_item_price)) + ")")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "1em",
      "margin-top": "-3em",
      "padding-top": "2em",
      "background": "#fff8fd",
      "border-radius": "8px"
    }
  }, [(!_vm.newBusinessForm) ? _c('div', {
    staticClass: "row onboarding-body"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-xs-12 col-md-6 onboarding-right"
  }, [(!_vm.loggedIn) ? _c('div', [(!_vm.set_up_with_existing_account) ? _c('div', [_c('div', {}, [_c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("Have an account? "), _c('a', {
    staticClass: "card-link",
    staticStyle: {
      "cursor": "pointer",
      "margin-bottom": "1em",
      "color": "#aa076b",
      "text-decoration": "underline !important"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('setup-existing', '')
      }
    }
  }, [_vm._v("Log In")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {}, [_c('form', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('label', [_vm._v("Full Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_name),
      expression: "payment_payer_name"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text",
      "placeholder": "Your full name"
    },
    domProps: {
      "value": (_vm.payment_payer_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_email),
      expression: "payment_payer_email"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.payment_payer_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('label', [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_phone),
      expression: "payment_payer_phone"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "number",
      "placeholder": "Phone (format: 09088776655)"
    },
    domProps: {
      "value": (_vm.payment_payer_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_password),
      expression: "user.user_password"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.user_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('label', [_vm._v("ReferralCode")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px",
      "color": "#ff0000"
    }
  }, [_vm._v("Enter Referral Code if any")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.referral_code),
      expression: "referral_code"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.referral_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.referral_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [(_vm.selected_plan_product_service_item.product_item_service_tag) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Subscription Duration: "), _c('b', [_vm._v(_vm._s(_vm.selected_plan_product_service_item.product_item_service_tag))])]), _c('br'), _vm._v(" "), _c('label', [_c('p', {
    staticClass: "sp-form-descr"
  }, [_c('b', [_vm._v("Total to pay: ₦" + _vm._s(_vm.setCurrency(_vm.selected_plan_product_service_item.product_item_price)))])])])]) : _vm._e(), _vm._v(" "), (_vm.selected_plan.product_items && (_vm.selected_plan.product_items.length > 1)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "gw-btn-cta-light",
    staticStyle: {
      "color": "#000000"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('display-product_service_items', '')
      }
    }
  }, [_vm._v("\r\n                                                                    Change Subscription Duration\r\n                                                                ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "border": "#aa076b dashed",
      "margin-top": "6px",
      "padding": "5px"
    },
    attrs: {
      "id": "productServiceItems"
    }
  }, _vm._l((_vm.selected_plan.product_items), function(pt) {
    return _c('div', {
      staticClass: "radio-items"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_service_items_select),
        expression: "product_service_items_select"
      }],
      attrs: {
        "type": "radio",
        "id": pt.product_item_id
      },
      domProps: {
        "value": pt.product_item_id,
        "checked": _vm._q(_vm.product_service_items_select, pt.product_item_id)
      },
      on: {
        "click": function($event) {
          _vm.selectProductServiceItem(pt)
        },
        "__c": function($event) {
          _vm.product_service_items_select = pt.product_item_id
        }
      }
    }), _vm._v(_vm._s(pt.product_item_service_tag) + "\r\n                                                                    ")])
  }))]) : _vm._e()]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.payment_successful) ? _c('div', {}, [_c('h3', {
    staticStyle: {
      "color": "#7c0b0b",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.payment_successful_message))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm sp-button-02",
    staticStyle: {
      "cursor": "pointer",
      "color": "#000000"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.setUpNewAccount()
      }
    }
  }, [_vm._v(" Proceed")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _c('div', [_c('div', {}, [_c('div', {
    staticClass: "pull-right"
  }, [_c('p', {
    staticStyle: {
      "float": "right",
      "margin-top": "1em"
    }
  }, [_vm._v("Don't have an account? "), _c('a', {
    staticClass: "card-link",
    staticStyle: {
      "cursor": "pointer",
      "margin-bottom": "1em",
      "color": "#aa076b",
      "text-decoration": "underline !important"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('not-setup-existing', '')
      }
    }
  }, [_vm._v("Sign Up")])])]), _vm._v(" "), _c('p', {
    staticClass: "pull-left",
    staticStyle: {
      "color": "#aa076b"
    }
  }, [_vm._v("Provide your account details to sign in")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('form', {
    staticClass: "form-inline"
  }, [_c('div', [_c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_password),
      expression: "user.user_password"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.user_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.payment_successful) ? _c('div', {}, [_c('h3', {
    staticStyle: {
      "color": "#7c0b0b",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.payment_successful_message))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm sp-button-02",
    staticStyle: {
      "cursor": "pointer",
      "color": "#000000"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.setUpWithAccount()
      }
    }
  }, [_vm._v(" Proceed")])])])])])])]) : _c('div', [(!_vm.set_checkout) ? _c('div', [(Object.keys(_vm.user_businesses).length > 0) ? _c('div', {
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('h3', [_vm._v("Activate for Shop:")]), _vm._v(" "), (Object.keys(_vm.user_businesses).length > 1) ? _c('div', _vm._l((_vm.user_businesses), function(business) {
    return _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected_business),
        expression: "selected_business"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": business,
        "checked": _vm._q(_vm.selected_business, business)
      },
      on: {
        "__c": function($event) {
          _vm.selected_business = business
        }
      }
    }), _vm._v(" " + _vm._s(business.business_name) + "\r\n                                                        ")])
  })) : _c('p', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.selected_business.business_name))]), _vm._v(" "), _c('div', [(_vm.order_amount > 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Subscription Duration: "), _c('b', [_vm._v(_vm._s(_vm.selected_plan_product_service_item.product_item_service_tag))])]), _c('br'), _vm._v(" "), _c('label', [_c('p', {
    staticClass: "sp-form-descr"
  }, [_c('b', [_vm._v("Total to pay: ₦" + _vm._s(_vm.setCurrency(_vm.order_amount_to_pay)))])])])]) : _vm._e(), _vm._v(" "), (_vm.selected_plan.product_items && (_vm.selected_plan.product_items.length > 1)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "gw-btn-cta-light",
    staticStyle: {
      "color": "#000000"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('display-product_service_items', '')
      }
    }
  }, [_vm._v("\r\n                                                                Change Subscription Duration\r\n                                                            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "border": "#aa076b dashed",
      "margin-top": "6px",
      "padding": "5px"
    },
    attrs: {
      "id": "productServiceItems"
    }
  }, _vm._l((_vm.selected_plan.product_items), function(pt) {
    return _c('div', {
      staticClass: "radio-items"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_service_items_select),
        expression: "product_service_items_select"
      }],
      attrs: {
        "type": "radio",
        "id": pt.product_item_id
      },
      domProps: {
        "value": pt.product_item_id,
        "checked": _vm._q(_vm.product_service_items_select, pt.product_item_id)
      },
      on: {
        "click": function($event) {
          _vm.selectProductServiceItem(pt)
        },
        "__c": function($event) {
          _vm.product_service_items_select = pt.product_item_id
        }
      }
    }), _vm._v(_vm._s(pt.product_item_service_tag) + "\r\n                                                                ")])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.payment_successful) ? _c('div', {}, [_c('h3', {
    staticStyle: {
      "color": "#7c0b0b",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.payment_successful_message))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm sp-button-02",
    staticStyle: {
      "cursor": "pointer",
      "color": "#000000"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.setAsUpgradePlan()
      }
    }
  }, [_vm._v(" Proceed")])])]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You can also set up a new business")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs sp-button-02",
    staticStyle: {
      "cursor": "pointer",
      "color": "#000000"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.setComponent('show-new-business-form', '')
      }
    }
  }, [_vm._v(" Set up Business")])])]) : _c('div', [_c('h3', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You do not have any business, to activate this plan on yet.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs sp-button-02",
    staticStyle: {
      "cursor": "pointer",
      "color": "#000000"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.setComponent('show-new-business-form', '')
      }
    }
  }, [_vm._v(" Set up Business")])])]) : _c('div', [_c('h3', [_vm._v("Payment Details")]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.set_checkout = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [(_vm.payment_payer_email != '') ? _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.payment_payer_email))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('label', [_vm._v("Have a coupon ?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px",
      "color": "#ff0000"
    }
  }, [_vm._v("Enter Coupon Code if any or just click Make Payment")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order_coupon),
      expression: "order_coupon"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.order_coupon)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.order_coupon = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))])]), _vm._v(" "), (_vm.payment_payer_email == '') ? _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('p', {
    staticStyle: {
      "font-size": "12px",
      "color": "#ff0000"
    }
  }, [_vm._v("Please enter your email address to make payment")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_email),
      expression: "payment_payer_email"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.payment_payer_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_email = $event.target.value
      }
    }
  })]) : _c('div', [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm sp-button-02",
    staticStyle: {
      "cursor": "pointer",
      "color": "#000000"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.setProcessPayment()
      }
    }
  }, [_vm._v(" Make Payment")])])])])])])]) : _c('div', {
    staticClass: "row onboarding-body"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-xs-12 col-md-6 onboarding-right"
  }, [_vm._m(7), _vm._v(" "), _c('div', {}, [_c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Business Name  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_name),
      expression: "business.business_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.business.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Business Username "), (_vm.validate_user_name_error) ? _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.validate_user_name_message))]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_user_name),
      expression: "business.business_user_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.business.business_user_name)
    },
    on: {
      "change": _vm.validateUserName,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Business Category Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_category_type),
      expression: "business_category_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business_category_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Products")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Services")])])]), _vm._v(" "), (_vm.business_category_type == 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select a Product Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.business_product_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.business_category_type == 2) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select a Service Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.business_service_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn gw-btn-cta-light",
    staticStyle: {
      "color": "#000000"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.setUpNewAccountBusiness
    }
  }, [_vm._v("Create")])])])])])])])])])])])]) : _c('section', {
    staticClass: "pricing-style-one gw-mtp",
    attrs: {
      "id": "pricing"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "margin": "1.3em",
      "margin-bottom": "4em"
    }
  }, [_vm._m(8), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(9)]) : _c('div', {
    staticClass: "row"
  }, [((Object.keys(_vm.picked_plan).length == 0)) ? _c('div', [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-xs-6",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.picked_plan = _vm.plan1
      }
    }
  }, [_c('div', {
    staticClass: "card-purchase basic-pack"
  }, [_vm._l((_vm.plan1.product_items), function(item) {
    return (item.product_item_service_tag == '1 year') ? _c('div', {
      staticClass: "top-block"
    }, [_c('p', {
      staticClass: "pack-name"
    }, [_vm._v(_vm._s(_vm.plan1.product_name))]), _vm._v(" "), _c('p', {
      staticClass: "price"
    }, [_vm._v("₦" + _vm._s(_vm.setCurrency(item.product_item_price)))]), _vm._v(" "), _c('p', {
      staticClass: "pack-tag"
    }, [_vm._v("per year")]), _c('p', {
      staticClass: "pack-descr"
    }, [_vm._v("* Direct Personal Discounts ")])]) : _vm._e()
  }), _vm._v(" "), _vm._m(10)], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-xs-6",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.picked_plan = _vm.plan2
      }
    }
  }, [_c('div', {
    staticClass: "card-purchase pro-pack"
  }, _vm._l((_vm.plan2.product_items), function(item) {
    return (item.product_item_service_tag == '1 year') ? _c('div', {
      staticClass: "top-block"
    }, [_c('p', {
      staticClass: "pack-name"
    }, [_vm._v(_vm._s(_vm.plan2.product_name))]), _vm._v(" "), _c('p', {
      staticClass: "price"
    }, [_vm._v("₦" + _vm._s(_vm.setCurrency(item.product_item_price)))]), _vm._v(" "), _c('p', {
      staticClass: "pack-tag"
    }, [_vm._v("per year")]), _c('p', {
      staticClass: "pack-descr"
    }, [_vm._v("* Direct Personal Discounts ")])]) : _vm._e()
  })), _vm._v(" "), _vm._m(11)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-xs-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.picked_plan = _vm.plan3
      }
    }
  }, [_c('div', {
    staticClass: "card-purchase biz-pack"
  }, _vm._l((_vm.plan3.product_items), function(item) {
    return (item.product_item_service_tag == '1 year') ? _c('div', {
      staticClass: "top-block"
    }, [_c('p', {
      staticClass: "pack-name"
    }, [_vm._v(_vm._s(_vm.plan3.product_name))]), _vm._v(" "), _c('p', {
      staticClass: "price"
    }, [_vm._v("₦" + _vm._s(_vm.setCurrency(item.product_item_price)))]), _vm._v(" "), _c('p', {
      staticClass: "pack-tag"
    }, [_vm._v("per year")]), _c('p', {
      staticClass: "pack-descr"
    }, [_vm._v("* Direct Personal Discounts ")])]) : _vm._e()
  })), _vm._v(" "), _vm._m(12)])])]) : _c('div', {
    staticClass: "category-slide",
    staticStyle: {
      "margin-top": "2.9em",
      "background": "#ffffff"
    }
  }, [_c('a', {
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.picked_plan = {}
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" Back")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('ul', [((Object.keys(_vm.picked_plan).length > 0)) ? _c('li', [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "card-purchase basic-pack"
  }, [_vm._l((_vm.picked_plan.product_items), function(item) {
    return (item.product_item_service_tag == '1 year') ? _c('div', {
      staticClass: "container"
    }, [_c('p', {
      staticClass: "pack-name"
    }, [_vm._v(_vm._s(_vm.picked_plan.product_name))]), _vm._v(" "), _c('p', {
      staticClass: "price"
    }, [_vm._v("₦" + _vm._s(_vm.setCurrency(item.product_item_price)))]), _vm._v(" "), _c('p', {
      staticClass: "pack-tag"
    }, [_vm._v("per year")]), _c('p', {
      staticClass: "pack-descr"
    }, [_vm._v("* Direct Personal Discounts ")])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-block"
  }, [_c('button', {
    staticClass: "btn btn-sm sp-button-02",
    on: {
      "click": function($event) {
        _vm.purchase_plan_2(_vm.picked_plan, 'n')
      }
    }
  }, [_vm._v("Purchase")])])], 2)])]) : _vm._e(), _vm._v(" "), (_vm.picked_plan.product_id != _vm.plan1.product_id) ? _c('li', [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "card-purchase basic-pack"
  }, [_vm._l((_vm.plan1.product_items), function(item) {
    return (item.product_item_service_tag == '1 year') ? _c('div', {
      staticClass: "container"
    }, [_c('p', {
      staticClass: "pack-name"
    }, [_vm._v(_vm._s(_vm.plan1.product_name))]), _vm._v(" "), _c('p', {
      staticClass: "price"
    }, [_vm._v("₦" + _vm._s(_vm.setCurrency(item.product_item_price)))]), _vm._v(" "), _c('p', {
      staticClass: "pack-tag"
    }, [_vm._v("per year")]), _c('p', {
      staticClass: "pack-descr"
    }, [_vm._v("* Direct Personal Discounts ")])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-block"
  }, [_c('button', {
    staticClass: "btn btn-sm sp-button-02",
    on: {
      "click": function($event) {
        _vm.purchase_plan_2(_vm.plan1, 'n')
      }
    }
  }, [_vm._v("Purchase")])])], 2)])]) : _vm._e(), _vm._v(" "), (_vm.picked_plan.product_id != _vm.plan2.product_id) ? _c('li', [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "card-purchase pro-pack"
  }, [_vm._l((_vm.plan2.product_items), function(item) {
    return (item.product_item_service_tag == '1 year') ? _c('div', {
      staticClass: "top-block"
    }, [_c('p', {
      staticClass: "pack-name"
    }, [_vm._v(_vm._s(_vm.plan2.product_name))]), _vm._v(" "), _c('p', {
      staticClass: "price"
    }, [_vm._v("₦" + _vm._s(_vm.setCurrency(item.product_item_price)))]), _vm._v(" "), _c('p', {
      staticClass: "pack-tag"
    }, [_vm._v("per year")]), _c('p', {
      staticClass: "pack-descr"
    }, [_vm._v("* Direct Personal Discounts ")])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-block"
  }, [_c('button', {
    staticClass: "btn btn-sm sp-button-02",
    on: {
      "click": function($event) {
        _vm.purchase_plan_2(_vm.plan2, 'n')
      }
    }
  }, [_vm._v("Purchase")])])], 2)])]) : _vm._e(), _vm._v(" "), (_vm.picked_plan.product_id != _vm.plan3.product_id) ? _c('li', [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "card-purchase biz-pack"
  }, [_vm._l((_vm.plan3.product_items), function(item) {
    return (item.product_item_service_tag == '1 year') ? _c('div', {
      staticClass: "top-block"
    }, [_c('p', {
      staticClass: "pack-name"
    }, [_vm._v(_vm._s(_vm.plan3.product_name))]), _vm._v(" "), _c('p', {
      staticClass: "price"
    }, [_vm._v("₦" + _vm._s(_vm.setCurrency(item.product_item_price)))]), _vm._v(" "), _c('p', {
      staticClass: "pack-tag"
    }, [_vm._v("per year")]), _vm._v(" "), _c('p', {
      staticClass: "pack-descr"
    }, [_vm._v("* Direct Personal Discounts ")])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-block"
  }, [_c('button', {
    staticClass: "btn btn-sm sp-button-02",
    on: {
      "click": function($event) {
        _vm.purchase_plan_2(_vm.plan3, 'n')
      }
    }
  }, [_vm._v("Purchase")])])], 2)])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "tab-pane show active  animated fadeInUp",
    attrs: {
      "role": "tabpanel",
      "id": "monthly"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4"
  }, [_c('div', {
    staticClass: "card-purchase basic-pack"
  }, [_c('div', {
    staticClass: "top-block"
  }, [((_vm.plan1.product_items && _vm.plan1.product_items.length > 0)) ? _c('span', {
    staticClass: "price"
  }, [_vm._v("₦" + _vm._s(_vm.plan1.product_items[0].product_item_price))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pack-name"
  }, [_vm._v(_vm._s(_vm.plan1.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "bottom-block"
  }, [_c('a', {
    staticClass: "price-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.purchase_plan_2(_vm.plan1, 'n')
      }
    }
  }, [_vm._v("Purchase")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4"
  }, [_c('div', {
    staticClass: "card-purchase pro-pack"
  }, [_c('div', {
    staticClass: "top-block"
  }, [((_vm.plan2.product_items && _vm.plan2.product_items.length > 0)) ? _c('span', {
    staticClass: "price"
  }, [_vm._v("₦" + _vm._s(_vm.plan2.product_items[0].product_item_price) + "/mo")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pack-name"
  }, [_vm._v(_vm._s(_vm.plan2.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "bottom-block"
  }, [_c('a', {
    staticClass: "price-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.purchase_plan_2(_vm.plan2, 'n')
      }
    }
  }, [_vm._v("Purchase")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4"
  }, [_c('div', {
    staticClass: "card-purchase biz-pack"
  }, [_c('div', {
    staticClass: "top-block"
  }, [((_vm.plan3.product_items && _vm.plan3.product_items.length > 0)) ? _c('span', {
    staticClass: "price"
  }, [_vm._v("₦" + _vm._s(_vm.plan3.product_items[0].product_item_price) + "/mo")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pack-name"
  }, [_vm._v(_vm._s(_vm.plan3.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "bottom-block"
  }, [_c('a', {
    staticClass: "price-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.purchase_plan_2(_vm.plan3, 'n')
      }
    }
  }, [_vm._v("Purchase")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane animated fadeInUp",
    attrs: {
      "role": "tabpanel",
      "id": "yearly"
    }
  })])])])]), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-title text-center"
  }, [_c('h2', {
    staticStyle: {
      "color": "#000000"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "true",
      "disabled": "disabled"
    }
  }), _vm._v(" By proceeding, you agree with the "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0055",
      "font-weight": "bold"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#terms-modal",
      "href": "#"
    }
  }, [_vm._v("Terms and Conditions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "true",
      "disabled": "disabled"
    }
  }), _vm._v(" By proceeding, you agree with the "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0055",
      "font-weight": "bold"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#terms-modal",
      "href": "#"
    }
  }, [_vm._v("Terms and Conditions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "true",
      "disabled": "disabled"
    }
  }), _vm._v(" By proceeding, you agree with the "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0055",
      "font-weight": "bold"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#terms-modal",
      "href": "#"
    }
  }, [_vm._v("Terms and Conditions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gw-mobile"
  }, [_c('h6', {
    staticClass: "gw-mobile",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Setup New Sellpoint Account")]), _vm._v(" "), _c('p', {
    staticClass: "sp-form-descr"
  }, [_vm._v("Setup New Sellpoint Account......")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "padding-top": "3em"
    }
  }, [_c('h2', {
    staticStyle: {
      "color": "#1f0113"
    }
  }, [_vm._v("Choose your plan")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pack-btm"
  }, [_c('i', {
    staticClass: "fa fa-angle-down",
    staticStyle: {
      "text-align": "center"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pack-btm"
  }, [_c('i', {
    staticClass: "fa fa-angle-down",
    staticStyle: {
      "text-align": "center"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pack-btm"
  }, [_c('i', {
    staticClass: "fa fa-angle-down",
    staticStyle: {
      "text-align": "center"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "feature-lists"
  }, [_c('li', [_vm._v("Max. 2 lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Max. of 5 posts per Lookbook")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "feature-lists"
  }, [_c('li', [_vm._v("Max. 10 Lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Unlimited Posts per Lookbook")]), _vm._v(" "), _c('li', [_vm._v("Free .com.ng domain")]), _vm._v(" "), _c('li', [_vm._v("*Max Storage Space of 500mb")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "feature-lists"
  }, [_c('li', [_vm._v("Unlimited Lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Unlimited Posts")]), _vm._v(" "), _c('li', [_vm._v("Free .com.ng domain\r\n                                                    ")]), _c('li', [_vm._v("Online Store (Functionality)")]), _vm._v(" "), _c('li', [_vm._v("*Max Storage Space of 1Gb")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a42bc0e"}!./src/pages/Purchase/template.html
// module id = 528
// module chunks = 0